import type { FC } from 'react';

import type { IconProps } from '@crehana/compass.icons.outline/types';

type TPageZeroProps = {
  img: string;
  title: string;
  description?: string;
  showButton?: boolean;
  labelButton?: string;
  iconButton?: FC<IconProps>;
  onButtonClick?: () => void; // Agregamos una nueva prop para manejar el clic en el botón
};

const PageZero: React.FC<TPageZeroProps> = ({
  img,
  title,
  description,
  showButton = false,
  labelButton,
  iconButton: IconButton, // Renombramos iconButton a IconButton
  onButtonClick,
}) => {
  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };
  return (
    <div className=" tw-flex tw-py-0 tw-px-4 tw-justify-center tw-h-full tw-w-full">
      <div className="tw-inline-block">
        <div>
          <div className="tw-flex  tw-justify-center tw-items-center">
            <img src={img} className="tw-w-[16rem] tw-h-14.4" alt="page-zero" />
          </div>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center tw-pt-2.4">
          <span className="tw-font-subtitle4 tw-text-neutral-light-800">
            {title}
          </span>
        </div>
        {description && (
          <div className="tw-flex tw-justify-center tw-items-center tw-pt-0.8">
            <span className="tw-font-body4 tw-text-neutral-light-700">
              {description}
            </span>
          </div>
        )}

        {showButton && (
          <div className="tw-flex tw-justify-center tw-items-center tw-pt-2.4">
            <button
              type="button"
              onClick={handleClick}
              className="tw-btn-primary-s tw-btn-icon"
            >
              {IconButton && <IconButton size={16} />}
              {labelButton}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default PageZero;
